var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"park"}},[_c('header-nav'),_c('banner-component',{attrs:{"banner-data":_vm.pageData}}),_c('article-detail',{attrs:{"article-list-nav":_vm.pageData}}),_c('partner-list'),_c('common-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }